class CustomNewsletter extends HTMLElement {
  lisTsd = "list-builderssss";
  connectedCallback() {
    this.popup = this.querySelector("[data-popup]");
    this.successWrapper = this.querySelector("[data-success]");
    this.delay = parseInt(this.getAttribute("data-delay") || 6)*1000;
    this.closeBtn = Array.from(this.querySelectorAll("[data-close]"));
    this.isTestMode = this.getAttribute("data-test") === "true";
    if (this.isTestMode) {
      this.open();
    } else {
      this.sync();
    }
    this.initListener();
  }
  sync() {
    if (this.successWrapper) {
      this.open();
      localStorage.setItem(this.lisTsd, new Date().getTime());
    } else {
      this.interval = setInterval(() => {
        if (document.documentElement.scrollTop > 0) {
          clearInterval(this.interval);
          var delay = this.delay; // milliseconds
          var cookie_expire = 1;
          var cookie = localStorage.getItem(this.lisTsd);
          if (cookie == undefined || cookie == null) {
            cookie = 0;
          }

          if (this.querySelector("[data-success]") > 0) {
          } else {
            if (
              (new Date().getTime() - cookie) / (1000 * 60 * 60 * 24) >
              cookie_expire
            ) {
              setTimeout(() => {
                this.open()
              }, delay);
            }
          }
        }
      });
    }
  }
  open() {
    this.popup.classList.add("isShow");
    const backdrop = this.querySelector(".newsletter-backdrop");
    if (backdrop) backdrop.classList.add("isShow");
  }

  close() {
  this.popup.classList.add("hidding");
  const backdrop = this.querySelector(".newsletter-backdrop");
  if (backdrop) backdrop.classList.remove("isShow");

  setTimeout(() => {
    this.popup.classList.remove("isShow");
    this.popup.classList.remove("hidding");
  }, 600);

  localStorage.setItem(this.lisTsd, new Date().getTime());
}
  initListener() {
    this.closeBtn.forEach((btn) =>
      btn.addEventListener("click", this.close.bind(this))
    );
    const backdrop = this.querySelector(".newsletter-backdrop");
    if (backdrop) {
      backdrop.addEventListener("click", this.close.bind(this));
    }
  }
  reset(){
    localStorage.removeItem(this.lisTsd);
  }
}
customElements.define("custom-newsletter", CustomNewsletter);